"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CarouselLightboxButton: ()=>CarouselLightboxButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../IconButton/index.cjs");
const CarouselLightboxButton = ({ iconButtonProps = {}, lightboxButtonClasses = '', ...props })=>{
    const { iconName = 'photo_library', size = '3xs', ...restProps } = iconButtonProps;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: lightboxButtonClasses,
        ...props,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.IconButton, {
            "data-testid": "carousel-lightbox-button",
            type: "plainPrimary",
            emphasis: "bold",
            size: size,
            iconName: iconName,
            ...restProps
        })
    });
};
exports.CarouselLightboxButton = __webpack_exports__.CarouselLightboxButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselLightboxButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
